import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const Container = styled(FlexRow)`
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
`;

Container.displayName = "Container";
